var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.localNavItems.length > 0
    ? _c(
        "ul",
        { staticClass: "ns-secondary-nav" },
        _vm._l(_vm.localNavItems, function(link) {
          return _c("li", { key: link.name, staticClass: "list-item" }, [
            _c(
              "a",
              { staticClass: "nav-link", attrs: { href: link.href } },
              [
                _c("span", [_vm._v(_vm._s(link.name))]),
                _vm._v(" "),
                _c("iron-icon", {
                  staticClass: "right-arrow",
                  attrs: { icon: "nuskin-24:icon-narrow-angle-right" }
                })
              ],
              1
            )
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }